import styled from '@emotion/styled'
import { Point } from 'google-map-react'

export const PopupWrapper = styled.div<{
  mapProperty?: {
    inCenterHalf: boolean
    position?: Point
    quadrant: { east?: boolean; north?: boolean; south?: boolean; west?: boolean }
  }
  mapSize: { height: number | null; width: number | null }
  remValue: number
}>`
  position: absolute;

  // map reports its size in pixels, set min max bounds
  --map-height: ${({ mapSize, remValue }) => {
    if (mapSize.height && mapSize.height / 2 - 50 < remValue * 30.5) {
      return `${mapSize.height / 2}px`
    } else {
      return '30.5rem'
    }
  }};
  --map-width: ${({ mapSize, remValue }) => {
    if (mapSize.width && mapSize.width / 2 - 50 < remValue * 22.5) {
      return `${mapSize.width / 2 - 24}px`
    } else {
      return '23rem'
    }
  }};
  width: var(--map-width);
  max-width: 23rem;
  min-width: 18.75rem;
  height: var(--map-height);
  max-height: 30rem;
  left: ${({ mapProperty }) => `${mapProperty?.position?.x}px`};
  top: ${({ mapProperty }) => `${mapProperty?.position?.y}px`};
  transform: ${({ mapProperty }) =>
    `translateX(${mapProperty?.quadrant.west ? '3rem' : 'calc(-100% - 1rem)'})
     translateY(${
       mapProperty?.quadrant.south
         ? `calc(${mapProperty?.inCenterHalf ? '-50%' : '-100%'} - 1rem)`
         : `calc(${mapProperty?.inCenterHalf ? '-50%' : '3rem'} )`
     })`};
`

export const ModalPopupDiv = styled('div')`
  width: 90vw;
  max-height: calc((var(--vh, 1vh) * 80));
  overflow-y: scroll;
`

export const PopupContents = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-width: 1px;
  border-style: solid;
  background-color: white;
  border-color: white;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 0px 8px 64px rgba(0, 0, 0, 0.16);

  @media (min-width: 768px) {
    border-width: 2px;
    border-radius: 1.5rem;
  }
`

export const PopupFigure = styled.figure`
  width: 100%;
  border-radius: 0.25rem 0.25rem 0 0;

  picture {
    display: block;
    overflow: hidden;
  }

  img {
    width: 100%;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: -2.25rem;
  right: 0;
  padding: 0.5rem;
  background-color: white;
  border-radius: 0.75rem;
  -webkit-box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
`

export const HomeListWrapper = styled.a`
  &:last-of-type {
    border-bottom: none;
  }
`

export const PopupArrow = styled.div`
  position: absolute;
  left: 50%;
  width: 1.75rem;
  height: 1.75rem;
  background-color: white;
  border-radius: 0 0 0.125rem 0;
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transform: translateX(-50%) translateY(-1rem) rotate(45deg) skewX(-6deg) skewY(-6deg);
  opacity: none;
  z-index: -1;
`

export const StyledTabs = styled.div`
  .title-container {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    width: 100%;
  }
  .tab-title {
    position: relative;

    button {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      height: 1.5rem;
      color: #2e2b29;
      white-space: nowrap;
      font-size: 0.875rem;
      line-height: 1;
      border-radius: 0.25rem;
    }

    &.active {
      button {
        color: white;
        font-weight: 700;
        background-color: black;
      }
    }
  }

  .active-tab {
    .tab-data-container {
      display: block;
    }
  }
  .tab-data-container {
    display: none;
  }
`
